import { createContext } from "react";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { configMiddleware } from "../features/config/middleware.js";
import { configSlice } from "../features/config/reducer.js";
import { formsMiddleware } from "../features/forms/middleware.js";
import { formsSlice } from "../features/forms/reducer.js";
import "../features/forms/selectors.js";
import { stagesMiddleware } from "../features/stages/middleware.js";
import { stagesSlice } from "../features/stages/reducer.js";
import "../features/stages/selectors.js";
import { rtkQueryErrorLoggerMiddleware } from "../shared/lib/store/rtkQueryErrorLoggerMiddleware.js";
const StoreContext = createContext(null);
const rootReducer = combineReducers({
  [configSlice.reducerPath]: configSlice.reducer,
  [stagesSlice.reducerPath]: stagesSlice.reducer,
  [formsSlice.reducerPath]: formsSlice.reducer
});
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend([
    configMiddleware,
    formsMiddleware,
    stagesMiddleware,
    rtkQueryErrorLoggerMiddleware
  ]),
  devTools: process.env.NODE_ENV !== "production"
});
export {
  StoreContext,
  store
};
